import React, { useEffect, useState } from "react";

export default function Header({ imgloading, altloading }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    document.body.classList.remove("hold-transition");
    const timer = window.setTimeout(() => {
      setVisible(false);
    }, 350);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="preloader flex-column justify-content-center align-items-center">
      <img className="animation__shake" src={(process.env.PUBLIC_URL || "") + imgloading} alt={altloading} height={60} width={60} />
    </div>
  );
}

Header.defaultProps = {
  imgloading: "/loading-default.png",
  altloading: "Wait...",
};
